import React from "react";
import {Trans} from "@language/Translator";

const PrePaidDS = () => {
    return <p>
        <Trans>payment_ds_sync</Trans>
    </p>
}

export default PrePaidDS;